import PropTypes from 'prop-types';
import React from 'react';
import {
  NavLink,
  withRouter,
} from 'react-router-dom';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import styles from './Navigation.css';
import { clickOnEnter } from '../../utils/genericHelpers';

const Link = ({
  hover,
  setHover,
  active,
  setActive,
  color,
  style,
  dispatch,
  staticContext,
  // eslint-disable-next-line react/prop-types
  match,
  history,
  children,
  identifier,
  trackAnalytics,
  ...props
}) => (
  <NavLink
    activeStyle={{ color }}
    className={styles.navListItem}
    style={{
      borderBottom: active ? `1px solid ${color}` : 'none',
      ...style,
    }}
    aria-current={active ? 'page' : undefined}
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
    onKeyDown={(e) => {
      trackAnalytics();
      clickOnEnter(e, () => {
        setTimeout(() => document.getElementById('skip-to-content').focus(), 0);
      });
    }}
    onClick={() => {
      trackAnalytics();
      setActive(identifier);
    }}
    {...props}
  >
    <div className={styles.navListEl}>
      <span
        style={{
          color: active ? color : '#2E333B',
          fontWeight: active ? 700 : 400,
        }}
        className={styles.navItemTitle}
      >
        {children}
      </span>
    </div>
  </NavLink>
);


Link.propTypes = {
  hover: PropTypes.bool,
  setHover: PropTypes.func,
  color: PropTypes.string,
  active: PropTypes.bool,
  style: PropTypes.object,
  identifier: PropTypes.string,
  setActive: PropTypes.func,
  trackAnalytics: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  history: PropTypes.object,
  staticContext: PropTypes.object,
  dispatch: PropTypes.func,
};

Link.defualtProps = {
  style: {},
  className: '',
};

export default compose(
  withState('hover', 'setHover', false),
  withRouter,
  connect(({ theme }) => ({
    color: theme.primaryColor,
  })),
)(Link);



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/Link.js